import { TopBarPageContainer } from "@components/PageContainer";
import { RouteObject, useParams } from "react-router-dom";

export const PASSTHRU_ACH_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { PassthruTable } = await import("@pages/passthru_ach_manager/PassthruTable");
      return {
        Component() {
          return (
            <TopBarPageContainer title={["Transactions", "ACH Manager", "Pass-thru"]}>
              <PassthruTable />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    path: ":submissionId/:entryId?",
    async lazy() {
      const { PassthruFileDetail } = await import("@pages/passthru_ach_manager/PassthruFileDetail");
      return {
        Component() {
          const { submissionId, entryId } = useParams<{ submissionId: string; entryId?: string }>();
          return (
            <PassthruFileDetail key={submissionId} submissionId={submissionId!} entryId={entryId} />
          );
        },
      };
    },
  },
];
